export default __webpack_public_path__ + "static/media/fasting_success_key@3x.700cfaad.jpg";